module.exports = __webpack_public_path__ + "media/images/common/purchase_btn-d4d8ab5001a5c0e406cbf0ad94250253.gif";